import { FormControl, TextField } from '@mui/material';
import _ from 'lodash';
import { useEffect } from 'react';
import { FormLabelText } from '../../../../components/style/TextStyle';
import { FacilityFormMode } from '../../../../utils/enum';

const fieldStyle = {
  '& fieldset': {
    border: 'none',
  },
  '& input': {
    backgroundColor: '#F8F8F8',
    borderRadius: '10px',
  },
  '& .MuiFormHelperText-root': {
    color: '#DB2828',
  },
};

export function FacilityField({ form, fieldName, mode, children }: any) {
  useEffect(() => {
    const list = _.isArray(fieldName) ? fieldName : [fieldName];

    for (let name of list) {
      if (mode === FacilityFormMode.REST) {
        form.unregister(name);
      } else {
        form.register(name);
      }
    }
  }, [fieldName, form, mode]);
  return mode === FacilityFormMode.SPORTING_GOODS ? <>{children}</> : <></>;
}

export function TextInput({
  form,
  fieldPath,
  placeholder,
  label,
  isRequired,
  type = 'text',
}: any) {
  const { errors, touchedFields: touched } = form.formState;
  return (
    <FormControl sx={{ width: '100%' }}>
      {label && (
        <FormLabelText>
          {label} {isRequired && <span style={{ color: '#FF5454' }}>*</span>}
        </FormLabelText>
      )}
      <TextField
        size="small"
        sx={fieldStyle}
        fullWidth
        placeholder={placeholder}
        inputProps={form?.register(`${fieldPath}`)}
        error={Boolean(touched?.fieldPath && errors?.fieldPath)}
        helperText={_.get(errors, `${fieldPath}.message`) as string}
        type={type}
      />
    </FormControl>
  );
}

export function UnLabelTextInput({
  form,
  fieldPath,
  placeholder,
  type = 'text',
  InputProps = {},
}: any) {
  const { errors, touchedFields: touched } = form.formState;
  return (
    <FormControl sx={{ width: '100%' }}>
      <TextField
        size="small"
        sx={fieldStyle}
        fullWidth
        placeholder={placeholder}
        inputProps={form?.register(`${fieldPath}`)}
        error={Boolean(touched?.fieldPath && errors?.fieldPath)}
        helperText={_.get(errors, `${fieldPath}.message`) as string}
        type={type}
        InputProps={InputProps}
      />
    </FormControl>
  );
}

export function TextAreaInput({
  form,
  fieldPath,
  placeholder,
  label,
  isRequired,
}: any) {
  const { errors, touchedFields: touched } = form.formState;
  return (
    <FormControl sx={{ width: '100%' }}>
      {label && (
        <FormLabelText>
          {label} {isRequired && <span style={{ color: '#FF5454' }}>*</span>}
        </FormLabelText>
      )}
      <TextField
        sx={{
          '& fieldset': {
            border: 'none',
          },
          backgroundColor: '#F8F8F8',
          borderRadius: '10px',
        }}
        fullWidth
        multiline
        rows={8}
        placeholder={placeholder}
        inputProps={form?.register(`${fieldPath}`)}
        error={Boolean(touched?.fieldPath && errors?.fieldPath)}
        helperText={_.get(errors, `${fieldPath}.message`) as string}
      />
    </FormControl>
  );
}

export function LoginInput({
  form,
  fieldPath,
  placeholder,
  label,
  isRequired,
  type = 'text',
}: any) {
  const { errors, touchedFields: touched } = form.formState;
  const hasError = Boolean(touched?.[fieldPath] && errors?.[fieldPath]);

  return (
    <FormControl sx={{ width: '100%' }}>
      {label && (
        <FormLabelText>
          {label} {isRequired && <span style={{ color: '#FF5454' }}>*</span>}
        </FormLabelText>
      )}
      <TextField
        size="small"
        sx={fieldStyle}
        fullWidth
        placeholder={placeholder}
        inputProps={form?.register(`${fieldPath}`)}
        error={hasError}
        helperText={hasError ? errors[fieldPath]?.message : ' '}
        type={type}
      />
    </FormControl>
  );
}
